export default class ComponentNotFoundError extends Error
{
    constructor(componentIndex: string) {
        super(`Component "${componentIndex}" not found`);
    }
}


// WEBPACK FOOTER //
// ./src/services/components/exception/ComponentNotFoundError.ts